import * as ActionTypes from '../action-types'

const vehicleReportFuelAnalysis_DefaultState = {
    reportByVID: {},
    logByVID: {},
    summaryByVID: {},
    allVIDs: [],
    selectedVID: ''
}

export const vehicleReportFuelAnalysis = (state = vehicleReportFuelAnalysis_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_VEHICLE_FUEL_ANALYSIS_REPORTS: {

            const reports = action.report
            const vid = action.vid

            // cleanup
            newState.reportByVID = {}
            newState.logByVID = {}
            newState.summaryByVID ={}
            newState.allVIDs = []
            newState.selectedVID = ''

            reports && reports.length && reports.map((report, index) => {
                const {
                    refuels = [],
                    thefts = [],
                    vLogs = [],
                    summary = {}
                } = report

                const i = index + 1
    
                if(vid) {

                    newState.selectedVID = vid
    
                    newState.reportByVID[`${vid}#${i}`] = {
                        refuels,
                        thefts
                    }
    
                    newState.logByVID[`${vid}#${i}`] = vLogs
                    newState.summaryByVID[`${vid}#${i}`] = summary
    
                    if(!newState.allVIDs.includes(vid)) newState.allVIDs.push(vid)
    
                }
            })


            return newState
        }
        case ActionTypes.CLEAR_VEHICLE_FUEL_ANALYSIS_REPORTS: {
            // cleanup
            newState.reportByVID = {}
            newState.logByVID = {}
            newState.summaryByVID ={}
            newState.allVIDs = []
            newState.selectedVID = ''

            return newState
        }
        default: {
            return newState;
        }
    }
}